import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

dayjs.extend(utc);

/**
 * MUI DateInput Component
 *
 * Props:
 * - label: Label text for the input.
 * - value: Date value as a string in "YYYY-MM-DD" or ISO format.
 * - onChange: Function to call with an event-like object { target: { value } } when date changes.
 * - allowToday: If true, a "Today" button is displayed.
 * - onTodaySelect: Optional callback when Today is selected.
 * - disabled: Disables the component if true.
 */
const DateInput = ({
  label,
  value,
  onChange = () => {},
  allowToday = false,
  onTodaySelect,
  disabled = false,
}) => {
  // Parse the incoming value (expected as "YYYY-MM-DD") as UTC.
  const parsedDate = value ? dayjs.utc(value, "YYYY-MM-DD") : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <div className="relative w-fit">
        <DatePicker
          label={label}
          value={parsedDate}
          onChange={(date) => {
            const formatted = dayjs.utc(date).format("YYYY-MM-DD");
            onChange({ target: { value: formatted } });
          }}
          format="DD-MM-YYYY"
          disabled={disabled}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "outlined",
              size: "small",
              disabled: disabled,
              InputLabelProps: {
                shrink: Boolean(value), // Keeps the label floating when value exists
              },
            },
          }}
          sx={{
    '& .MuiOutlinedInput-root': {
      height: 38,                  // Set the height of the input field
      display: 'flex',
      alignItems: 'center',        // Center the content vertically
    },
    '& .MuiOutlinedInput-input': {
      padding: '0 12px',           // Add padding inside the input
      fontSize: '0.875rem',        // Set font size
    },
  }}
        />
      </div>
    </LocalizationProvider>
  );
};

export default DateInput;